"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluckDefined = void 0;
exports.pluckDefined = (obj) => {
    const newObj = {};
    Object.keys(obj).forEach(k => {
        const v = obj[k];
        if (v !== null && v !== undefined) {
            newObj[k] = v;
        }
    });
    return newObj;
};
//# sourceMappingURL=pluckDefined.js.map